import { TOGGLE_APP_STATE, SET_VERSION_INFO, SET_AUTOMATIC_UPDATE } from '../actions/appState'
import { CURRENT_MENU_SELECTED } from '../actions/menus'

const initialState = {
  isActive: true,
  isAgeConfirmed: false,
  isAlcoholWarningConfirmed: false,
  currentMenuId: null,
  lastUserInteractionInSuites: null,
  updateAvailable: false,
  automaticallyUpdate: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_APP_STATE: {
      return { ...state, ...payload }
    }

    case CURRENT_MENU_SELECTED: {
      return {
        ...state,
        currentMenuId: payload,
      }
    }

    case SET_VERSION_INFO: {
      return {
        ...state,
        ...payload,
      }
    }

    case SET_AUTOMATIC_UPDATE: {
      return {
        ...state,
        automaticallyUpdate: payload.automaticallyUpdate,
      }
    }

    default:
      return state
  }
}
